module.exports = __webpack_public_path__ + "img/offer-pc-in.c6470c58.svg";